import axiosInstance from "../../utils/axiosInstance";
import { getAuthHeaders } from "../../utils/authHeader";

const BASE_URL = `/meetings`;

export const fetchMeetings = async () => {
  const res = await axiosInstance.get(`${BASE_URL}`, getAuthHeaders());
  return res.data;
};

export const createDummyMeetings = async () => {
  const res = await axiosInstance.get(`${BASE_URL}/dummy`, getAuthHeaders());
  return res.data;
};

export const createMeetingApi = async (formData) => {
  const isFormData =
    typeof FormData !== "undefined" && formData instanceof FormData;

  if (isFormData) {
    const headers = {
      ...getAuthHeaders(),
      headers: {
        ...getAuthHeaders().headers,
        "Content-Type": "multipart/form-data",
      },
    };

    const res = await axiosInstance.post(`${BASE_URL}`, formData, headers);
    return res.data;
  }

  const res = await axiosInstance.post(
    `${BASE_URL}`,
    formData,
    getAuthHeaders(),
  );
  return res.data;
};

export const fetchMeeting = async (meetingId) => {
  const res = await axiosInstance.get(
    `${BASE_URL}/${meetingId}`,
    getAuthHeaders(),
  );
  return res.data;
};

export const deleteMeetingApi = async (meetingId) => {
  const res = await axiosInstance.delete(
    `${BASE_URL}/${meetingId}`,
    getAuthHeaders(),
  );
  return res.data;
};

export const updateMeetingApi = async (meetingId, payload) => {
  const res = await axiosInstance.put(
    `${BASE_URL}/${meetingId}`,
    payload,
    getAuthHeaders(),
  );
  return res.data;
};

export const fetchMeetingTasks = async (conversation = false) => {
  const res = await axiosInstance.get(`${BASE_URL}/tasks`, getAuthHeaders());
  return res.data;
};

export const extractMeetingTasksApi = async (meetingId) => {
  const res = await axiosInstance.post(
    `${BASE_URL}/tasks/${meetingId}`,
    {},
    getAuthHeaders(),
  );
  return res.data;
};